import React, { FC } from 'react';
import AuthProvider from '../../contexts/auth-provider';
import Layout from './layout';
import { Route } from 'react-router-dom';
import ScrollToTop from '../scroll/scroll-to-top';


const LayoutRoute: FC<any> = ({ component: Component, ...rest }) => {
  return (
    <Route {...rest} render={(matchProps:any) => (
      <Layout>
        <AuthProvider>
          <ScrollToTop />
          <Component {...matchProps} />
        </AuthProvider>
      </Layout>
    )} />
  )
};

export default LayoutRoute;  